// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
#kayna .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
#kayna .pointer-events-none {
  pointer-events: none;
}
#kayna .visible {
  visibility: visible;
}
#kayna .invisible {
  visibility: hidden;
}
#kayna .fixed {
  position: fixed;
}
#kayna .absolute {
  position: absolute;
}
#kayna .relative {
  position: relative;
}
#kayna .sticky {
  position: sticky;
}
#kayna .inset-0 {
  inset: 0px;
}
#kayna .inset-y-1\\/3 {
  top: 33.333333%;
  bottom: 33.333333%;
}
#kayna .-left-4 {
  left: -1rem;
}
#kayna .-top-3 {
  top: -0.75rem;
}
#kayna .bottom-0 {
  bottom: 0px;
}
#kayna .bottom-12 {
  bottom: 3rem;
}
#kayna .bottom-5 {
  bottom: 1.25rem;
}
#kayna .bottom-full {
  bottom: 100%;
}
#kayna .left-0 {
  left: 0px;
}
#kayna .left-1 {
  left: 0.25rem;
}
#kayna .left-1\\/2 {
  left: 50%;
}
#kayna .left-4 {
  left: 1rem;
}
#kayna .left-5 {
  left: 1.25rem;
}
#kayna .left-6 {
  left: 1.5rem;
}
#kayna .left-\\[-40\\%\\] {
  left: -40%;
}
#kayna .right-0 {
  right: 0px;
}
#kayna .right-3 {
  right: 0.75rem;
}
#kayna .right-5 {
  right: 1.25rem;
}
#kayna .right-6 {
  right: 1.5rem;
}
#kayna .top-0 {
  top: 0px;
}
#kayna .top-1 {
  top: 0.25rem;
}
#kayna .top-1\\/2 {
  top: 50%;
}
#kayna .top-10 {
  top: 2.5rem;
}
#kayna .top-24 {
  top: 6rem;
}
#kayna .top-28 {
  top: 7rem;
}
#kayna .top-3 {
  top: 0.75rem;
}
#kayna .top-3\\/4 {
  top: 75%;
}
#kayna .top-4 {
  top: 1rem;
}
#kayna .top-5 {
  top: 1.25rem;
}
#kayna .top-6 {
  top: 1.5rem;
}
#kayna .top-8 {
  top: 2rem;
}
#kayna .top-\\[120px\\] {
  top: 120px;
}
#kayna .top-\\[calc\\(100\\%\\+4px\\)\\] {
  top: calc(100% + 4px);
}
#kayna .top-full {
  top: 100%;
}
#kayna .z-0 {
  z-index: 0;
}
#kayna .z-10 {
  z-index: 10;
}
#kayna .z-20 {
  z-index: 20;
}
#kayna .z-40 {
  z-index: 40;
}
#kayna .z-50 {
  z-index: 50;
}
#kayna .z-\\[1000\\] {
  z-index: 1000;
}
#kayna .z-\\[100\\] {
  z-index: 100;
}
#kayna .z-\\[1\\] {
  z-index: 1;
}
#kayna .z-\\[200\\] {
  z-index: 200;
}
#kayna .z-\\[40\\] {
  z-index: 40;
}
#kayna .z-\\[55\\] {
  z-index: 55;
}
#kayna .z-\\[56\\] {
  z-index: 56;
}
#kayna .col-span-2 {
  grid-column: span 2 / span 2;
}
#kayna .col-span-3 {
  grid-column: span 3 / span 3;
}
#kayna .col-span-5 {
  grid-column: span 5 / span 5;
}
#kayna .m-0 {
  margin: 0px;
}
#kayna .m-3 {
  margin: 0.75rem;
}
#kayna .m-auto {
  margin: auto;
}
#kayna .-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
#kayna .mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
#kayna .mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
#kayna .mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
#kayna .mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
#kayna .mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
#kayna .mx-auto {
  margin-left: auto;
  margin-right: auto;
}
#kayna .my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
#kayna .my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
#kayna .my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
#kayna .my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
#kayna .my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
#kayna .my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
#kayna .my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
#kayna .-ml-1 {
  margin-left: -0.25rem;
}
#kayna .-ml-2 {
  margin-left: -0.5rem;
}
#kayna .-ml-4 {
  margin-left: -1rem;
}
#kayna .-mr-2 {
  margin-right: -0.5rem;
}
#kayna .-mt-3 {
  margin-top: -0.75rem;
}
#kayna .mb-0 {
  margin-bottom: 0px;
}
#kayna .mb-0\\.5 {
  margin-bottom: 0.125rem;
}
#kayna .mb-1 {
  margin-bottom: 0.25rem;
}
#kayna .mb-10 {
  margin-bottom: 2.5rem;
}
#kayna .mb-12 {
  margin-bottom: 3rem;
}
#kayna .mb-2 {
  margin-bottom: 0.5rem;
}
#kayna .mb-3 {
  margin-bottom: 0.75rem;
}
#kayna .mb-4 {
  margin-bottom: 1rem;
}
#kayna .mb-5 {
  margin-bottom: 1.25rem;
}
#kayna .mb-6 {
  margin-bottom: 1.5rem;
}
#kayna .mb-8 {
  margin-bottom: 2rem;
}
#kayna .mb-\\[-8px\\] {
  margin-bottom: -8px;
}
#kayna .mb-\\[26px\\] {
  margin-bottom: 26px;
}
#kayna .mb-\\[4px\\] {
  margin-bottom: 4px;
}
#kayna .ml-1 {
  margin-left: 0.25rem;
}
#kayna .ml-11 {
  margin-left: 2.75rem;
}
#kayna .ml-2 {
  margin-left: 0.5rem;
}
#kayna .ml-2\\.5 {
  margin-left: 0.625rem;
}
#kayna .ml-3 {
  margin-left: 0.75rem;
}
#kayna .ml-4 {
  margin-left: 1rem;
}
#kayna .ml-5 {
  margin-left: 1.25rem;
}
#kayna .ml-6 {
  margin-left: 1.5rem;
}
#kayna .ml-\\[-0\\.5rem\\] {
  margin-left: -0.5rem;
}
#kayna .mr-1 {
  margin-right: 0.25rem;
}
#kayna .mr-2 {
  margin-right: 0.5rem;
}
#kayna .mr-3 {
  margin-right: 0.75rem;
}
#kayna .mr-4 {
  margin-right: 1rem;
}
#kayna .mr-\\[-1rem\\] {
  margin-right: -1rem;
}
#kayna .mr-\\[1px\\] {
  margin-right: 1px;
}
#kayna .mr-auto {
  margin-right: auto;
}
#kayna .mt-0\\.5 {
  margin-top: 0.125rem;
}
#kayna .mt-1 {
  margin-top: 0.25rem;
}
#kayna .mt-12 {
  margin-top: 3rem;
}
#kayna .mt-16 {
  margin-top: 4rem;
}
#kayna .mt-2 {
  margin-top: 0.5rem;
}
#kayna .mt-3 {
  margin-top: 0.75rem;
}
#kayna .mt-3\\.5 {
  margin-top: 0.875rem;
}
#kayna .mt-4 {
  margin-top: 1rem;
}
#kayna .mt-5 {
  margin-top: 1.25rem;
}
#kayna .mt-6 {
  margin-top: 1.5rem;
}
#kayna .mt-8 {
  margin-top: 2rem;
}
#kayna .mt-auto {
  margin-top: auto;
}
#kayna .block {
  display: block;
}
#kayna .inline-block {
  display: inline-block;
}
#kayna .inline {
  display: inline;
}
#kayna .flex {
  display: flex;
}
#kayna .inline-flex {
  display: inline-flex;
}
#kayna .table {
  display: table;
}
#kayna .grid {
  display: grid;
}
#kayna .hidden {
  display: none;
}
#kayna .aspect-\\[5\\/4\\] {
  aspect-ratio: 5/4;
}
#kayna .aspect-square {
  aspect-ratio: 1 / 1;
}
#kayna .size-4 {
  width: 1rem;
  height: 1rem;
}
#kayna .size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
#kayna .size-8 {
  width: 2rem;
  height: 2rem;
}
#kayna .size-\\[18px\\] {
  width: 18px;
  height: 18px;
}
#kayna .h-0 {
  height: 0px;
}
#kayna .h-1\\.5 {
  height: 0.375rem;
}
#kayna .h-10 {
  height: 2.5rem;
}
#kayna .h-11 {
  height: 2.75rem;
}
#kayna .h-12 {
  height: 3rem;
}
#kayna .h-14 {
  height: 3.5rem;
}
#kayna .h-16 {
  height: 4rem;
}
#kayna .h-2 {
  height: 0.5rem;
}
#kayna .h-2\\.5 {
  height: 0.625rem;
}
#kayna .h-20 {
  height: 5rem;
}
#kayna .h-3 {
  height: 0.75rem;
}
#kayna .h-3\\.5 {
  height: 0.875rem;
}
#kayna .h-4 {
  height: 1rem;
}
#kayna .h-5 {
  height: 1.25rem;
}
#kayna .h-6 {
  height: 1.5rem;
}
#kayna .h-64 {
  height: 16rem;
}
#kayna .h-7 {
  height: 1.75rem;
}
#kayna .h-8 {
  height: 2rem;
}
#kayna .h-9 {
  height: 2.25rem;
}
#kayna .h-\\[11px\\] {
  height: 11px;
}
#kayna .h-\\[15px\\] {
  height: 15px;
}
#kayna .h-\\[16px\\] {
  height: 16px;
}
#kayna .h-\\[1px\\] {
  height: 1px;
}
#kayna .h-\\[200px\\] {
  height: 200px;
}
#kayna .h-\\[24px\\] {
  height: 24px;
}
#kayna .h-\\[2px\\] {
  height: 2px;
}
#kayna .h-\\[40px\\] {
  height: 40px;
}
#kayna .h-\\[42px\\] {
  height: 42px;
}
#kayna .h-\\[440px\\] {
  height: 440px;
}
#kayna .h-\\[52px\\] {
  height: 52px;
}
#kayna .h-\\[60px\\] {
  height: 60px;
}
#kayna .h-\\[6px\\] {
  height: 6px;
}
#kayna .h-\\[72px\\] {
  height: 72px;
}
#kayna .h-\\[84px\\] {
  height: 84px;
}
#kayna .h-\\[90\\%\\] {
  height: 90%;
}
#kayna .h-\\[92vh\\] {
  height: 92vh;
}
#kayna .h-\\[95vh\\] {
  height: 95vh;
}
#kayna .h-auto {
  height: auto;
}
#kayna .h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
#kayna .h-full {
  height: 100%;
}
#kayna .h-max {
  height: -moz-max-content;
  height: max-content;
}
#kayna .h-px {
  height: 1px;
}
#kayna .h-screen {
  height: 100vh;
}
#kayna .max-h-6 {
  max-height: 1.5rem;
}
#kayna .max-h-60 {
  max-height: 15rem;
}
#kayna .max-h-\\[130px\\] {
  max-height: 130px;
}
#kayna .max-h-\\[160px\\] {
  max-height: 160px;
}
#kayna .max-h-\\[320px\\] {
  max-height: 320px;
}
#kayna .max-h-\\[400px\\] {
  max-height: 400px;
}
#kayna .max-h-\\[95vh\\] {
  max-height: 95vh;
}
#kayna .max-h-fit {
  max-height: -moz-fit-content;
  max-height: fit-content;
}
#kayna .min-h-\\[120px\\] {
  min-height: 120px;
}
#kayna .min-h-\\[160px\\] {
  min-height: 160px;
}
#kayna .min-h-\\[20px\\] {
  min-height: 20px;
}
#kayna .min-h-\\[22px\\] {
  min-height: 22px;
}
#kayna .min-h-\\[40px\\] {
  min-height: 40px;
}
#kayna .min-h-\\[44px\\] {
  min-height: 44px;
}
#kayna .min-h-\\[500px\\] {
  min-height: 500px;
}
#kayna .min-h-\\[52px\\] {
  min-height: 52px;
}
#kayna .min-h-\\[54px\\] {
  min-height: 54px;
}
#kayna .min-h-\\[60px\\] {
  min-height: 60px;
}
#kayna .min-h-\\[80px\\] {
  min-height: 80px;
}
#kayna .min-h-\\[84px\\] {
  min-height: 84px;
}
#kayna .min-h-\\[90px\\] {
  min-height: 90px;
}
#kayna .min-h-\\[90vh\\] {
  min-height: 90vh;
}
#kayna .min-h-full {
  min-height: 100%;
}
#kayna .w-0 {
  width: 0px;
}
#kayna .w-1\\/2 {
  width: 50%;
}
#kayna .w-10 {
  width: 2.5rem;
}
#kayna .w-10\\/12 {
  width: 83.333333%;
}
#kayna .w-11 {
  width: 2.75rem;
}
#kayna .w-11\\/12 {
  width: 91.666667%;
}
#kayna .w-12 {
  width: 3rem;
}
#kayna .w-14 {
  width: 3.5rem;
}
#kayna .w-16 {
  width: 4rem;
}
#kayna .w-2 {
  width: 0.5rem;
}
#kayna .w-2\\.5 {
  width: 0.625rem;
}
#kayna .w-2\\/3 {
  width: 66.666667%;
}
#kayna .w-20 {
  width: 5rem;
}
#kayna .w-24 {
  width: 6rem;
}
#kayna .w-3 {
  width: 0.75rem;
}
#kayna .w-3\\.5 {
  width: 0.875rem;
}
#kayna .w-3\\/4 {
  width: 75%;
}
#kayna .w-32 {
  width: 8rem;
}
#kayna .w-4 {
  width: 1rem;
}
#kayna .w-4\\/6 {
  width: 66.666667%;
}
#kayna .w-40 {
  width: 10rem;
}
#kayna .w-48 {
  width: 12rem;
}
#kayna .w-5 {
  width: 1.25rem;
}
#kayna .w-6 {
  width: 1.5rem;
}
#kayna .w-6\\/12 {
  width: 50%;
}
#kayna .w-64 {
  width: 16rem;
}
#kayna .w-72 {
  width: 18rem;
}
#kayna .w-8 {
  width: 2rem;
}
#kayna .w-8\\/12 {
  width: 66.666667%;
}
#kayna .w-9 {
  width: 2.25rem;
}
#kayna .w-\\[140px\\] {
  width: 140px;
}
#kayna .w-\\[1px\\] {
  width: 1px;
}
#kayna .w-\\[218px\\] {
  width: 218px;
}
#kayna .w-\\[230px\\] {
  width: 230px;
}
#kayna .w-\\[244px\\] {
  width: 244px;
}
#kayna .w-\\[25\\%\\] {
  width: 25%;
}
#kayna .w-\\[28\\%\\] {
  width: 28%;
}
#kayna .w-\\[296px\\] {
  width: 296px;
}
#kayna .w-\\[2px\\] {
  width: 2px;
}
#kayna .w-\\[30rem\\] {
  width: 30rem;
}
#kayna .w-\\[40\\%\\] {
  width: 40%;
}
#kayna .w-\\[6px\\] {
  width: 6px;
}
#kayna .w-\\[72px\\] {
  width: 72px;
}
#kayna .w-\\[80\\%\\] {
  width: 80%;
}
#kayna .w-\\[85px\\] {
  width: 85px;
}
#kayna .w-\\[90px\\] {
  width: 90px;
}
#kayna .w-\\[90vw\\] {
  width: 90vw;
}
#kayna .w-\\[95vw\\] {
  width: 95vw;
}
#kayna .w-\\[98px\\] {
  width: 98px;
}
#kayna .w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
#kayna .w-full {
  width: 100%;
}
#kayna .w-max {
  width: -moz-max-content;
  width: max-content;
}
#kayna .w-min {
  width: -moz-min-content;
  width: min-content;
}
#kayna .w-px {
  width: 1px;
}
#kayna .w-screen {
  width: 100vw;
}
#kayna .min-w-0 {
  min-width: 0px;
}
#kayna .min-w-24 {
  min-width: 6rem;
}
#kayna .min-w-\\[100px\\] {
  min-width: 100px;
}
#kayna .min-w-\\[512px\\] {
  min-width: 512px;
}
#kayna .min-w-\\[754px\\] {
  min-width: 754px;
}
#kayna .min-w-full {
  min-width: 100%;
}
#kayna .max-w-2xl {
  max-width: 42rem;
}
#kayna .max-w-3xl {
  max-width: 48rem;
}
#kayna .max-w-4xl {
  max-width: 56rem;
}
#kayna .max-w-\\[1002px\\] {
  max-width: 1002px;
}
#kayna .max-w-\\[1280px\\] {
  max-width: 1280px;
}
#kayna .max-w-\\[1300px\\] {
  max-width: 1300px;
}
#kayna .max-w-\\[150px\\] {
  max-width: 150px;
}
#kayna .max-w-\\[160px\\] {
  max-width: 160px;
}
#kayna .max-w-\\[288px\\] {
  max-width: 288px;
}
#kayna .max-w-\\[2rem\\] {
  max-width: 2rem;
}
#kayna .max-w-\\[310px\\] {
  max-width: 310px;
}
#kayna .max-w-\\[474px\\] {
  max-width: 474px;
}
#kayna .max-w-\\[568px\\] {
  max-width: 568px;
}
#kayna .max-w-\\[580px\\] {
  max-width: 580px;
}
#kayna .max-w-\\[588px\\] {
  max-width: 588px;
}
#kayna .max-w-\\[600px\\] {
  max-width: 600px;
}
#kayna .max-w-\\[680px\\] {
  max-width: 680px;
}
#kayna .max-w-\\[7\\.5rem\\] {
  max-width: 7.5rem;
}
#kayna .max-w-\\[70\\%\\] {
  max-width: 70%;
}
#kayna .max-w-\\[90vw\\] {
  max-width: 90vw;
}
#kayna .max-w-\\[95vw\\] {
  max-width: 95vw;
}
#kayna .max-w-\\[calc\\(100\\%-30px\\)\\] {
  max-width: calc(100% - 30px);
}
#kayna .max-w-fit {
  max-width: -moz-fit-content;
  max-width: fit-content;
}
#kayna .max-w-full {
  max-width: 100%;
}
#kayna .max-w-md {
  max-width: 28rem;
}
#kayna .max-w-xl {
  max-width: 36rem;
}
#kayna .max-w-xs {
  max-width: 20rem;
}
#kayna .flex-1 {
  flex: 1 1 0%;
}
#kayna .flex-shrink-0 {
  flex-shrink: 0;
}
#kayna .shrink-0 {
  flex-shrink: 0;
}
#kayna .flex-grow {
  flex-grow: 1;
}
#kayna .grow {
  flex-grow: 1;
}
#kayna .basis-full {
  flex-basis: 100%;
}
#kayna .border-collapse {
  border-collapse: collapse;
}
#kayna .-translate-x-1 {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#kayna .-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#kayna .-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#kayna .translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#kayna .translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#kayna .translate-x-8 {
  --tw-translate-x: 2rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
#kayna .transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
#kayna .animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes fadeOut {

  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
#kayna .animate-fadeOut {
  animation: fadeOut 6s ease-in-out forwards;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
#kayna .animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
#kayna .animate-spin {
  animation: spin 1s linear infinite;
}
#kayna .cursor-auto {
  cursor: auto;
}
#kayna .cursor-crosshair {
  cursor: crosshair;
}
#kayna .cursor-default {
  cursor: default;
}
#kayna .cursor-not-allowed {
  cursor: not-allowed;
}
#kayna .cursor-pointer {
  cursor: pointer;
}
#kayna .cursor-text {
  cursor: text;
}
#kayna .select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
#kayna .resize-none {
  resize: none;
}
#kayna .scroll-mt-6 {
  scroll-margin-top: 1.5rem;
}
#kayna .list-inside {
  list-style-position: inside;
}
#kayna .list-disc {
  list-style-type: disc;
}
#kayna .list-none {
  list-style-type: none;
}
#kayna .appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
#kayna .grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
#kayna .grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
#kayna .grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
#kayna .grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
#kayna .grid-cols-\\[0\\.5fr_1fr_1fr_1fr_1fr_1fr_1fr\\] {
  grid-template-columns: 0.5fr 1fr 1fr 1fr 1fr 1fr 1fr;
}
#kayna .grid-cols-\\[auto\\2c 1fr\\] {
  grid-template-columns: auto 1fr;
}
#kayna .grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(380px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(380px,1fr));
}
#kayna .grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
#kayna .flex-row {
  flex-direction: row;
}
#kayna .flex-row-reverse {
  flex-direction: row-reverse;
}
#kayna .flex-col {
  flex-direction: column;
}
#kayna .flex-wrap {
  flex-wrap: wrap;
}
#kayna .items-start {
  align-items: flex-start;
}
#kayna .items-end {
  align-items: flex-end;
}
#kayna .items-center {
  align-items: center;
}
#kayna .items-baseline {
  align-items: baseline;
}
#kayna .items-stretch {
  align-items: stretch;
}
#kayna .justify-start {
  justify-content: flex-start;
}
#kayna .justify-end {
  justify-content: flex-end;
}
#kayna .justify-center {
  justify-content: center;
}
#kayna .justify-between {
  justify-content: space-between;
}
#kayna .justify-around {
  justify-content: space-around;
}
#kayna .gap-1 {
  gap: 0.25rem;
}
#kayna .gap-1\\.5 {
  gap: 0.375rem;
}
#kayna .gap-12 {
  gap: 3rem;
}
#kayna .gap-2 {
  gap: 0.5rem;
}
#kayna .gap-3 {
  gap: 0.75rem;
}
#kayna .gap-4 {
  gap: 1rem;
}
#kayna .gap-5 {
  gap: 1.25rem;
}
#kayna .gap-6 {
  gap: 1.5rem;
}
#kayna .gap-8 {
  gap: 2rem;
}
#kayna .gap-\\[6px\\] {
  gap: 6px;
}
#kayna .gap-\\[8px\\] {
  gap: 8px;
}
#kayna .gap-x-1 {
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
#kayna .gap-x-1\\.5 {
  -moz-column-gap: 0.375rem;
       column-gap: 0.375rem;
}
#kayna .gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
#kayna .gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
#kayna .gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
#kayna .gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
#kayna .gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
#kayna .gap-y-1 {
  row-gap: 0.25rem;
}
#kayna .gap-y-10 {
  row-gap: 2.5rem;
}
#kayna .gap-y-2 {
  row-gap: 0.5rem;
}
#kayna .gap-y-20 {
  row-gap: 5rem;
}
#kayna .gap-y-3 {
  row-gap: 0.75rem;
}
#kayna .gap-y-4 {
  row-gap: 1rem;
}
#kayna .gap-y-6 {
  row-gap: 1.5rem;
}
#kayna :is(.space-x-1 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
#kayna :is(.space-x-2 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
#kayna :is(.space-y-0\\.5 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
#kayna :is(.space-y-1 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
#kayna :is(.space-y-2 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
#kayna :is(.space-y-3 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
#kayna :is(.space-y-4 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
#kayna :is(.space-y-6 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
#kayna :is(.space-y-8 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
#kayna :is(.divide-y > :not([hidden]) ~ :not([hidden])) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
#kayna :is(.divide-y-2 > :not([hidden]) ~ :not([hidden])) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(2px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(2px * var(--tw-divide-y-reverse));
}
#kayna :is(.divide-y-\\[1px\\] > :not([hidden]) ~ :not([hidden])) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
#kayna :is(.divide-\\[\\#E9EDF7B2\\] > :not([hidden]) ~ :not([hidden])) {
  border-color: #E9EDF7B2;
}
#kayna :is(.divide-slate-100 > :not([hidden]) ~ :not([hidden])) {
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
#kayna .self-start {
  align-self: flex-start;
}
#kayna .self-end {
  align-self: flex-end;
}
#kayna .self-center {
  align-self: center;
}
#kayna .overflow-auto {
  overflow: auto;
}
#kayna .overflow-hidden {
  overflow: hidden;
}
#kayna .overflow-x-auto {
  overflow-x: auto;
}
#kayna .overflow-y-auto {
  overflow-y: auto;
}
#kayna .overflow-x-hidden {
  overflow-x: hidden;
}
#kayna .overflow-y-hidden {
  overflow-y: hidden;
}
#kayna .overflow-y-scroll {
  overflow-y: scroll;
}
#kayna .scroll-smooth {
  scroll-behavior: smooth;
}
#kayna .truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#kayna .text-ellipsis {
  text-overflow: ellipsis;
}
#kayna .whitespace-normal {
  white-space: normal;
}
#kayna .whitespace-nowrap {
  white-space: nowrap;
}
#kayna .whitespace-pre-line {
  white-space: pre-line;
}
#kayna .text-balance {
  text-wrap: balance;
}
#kayna .text-pretty {
  text-wrap: pretty;
}
#kayna .break-words {
  overflow-wrap: break-word;
}
#kayna .break-all {
  word-break: break-all;
}
#kayna .rounded {
  border-radius: 0.25rem;
}
#kayna .rounded-2xl {
  border-radius: 1rem;
}
#kayna .rounded-3xl {
  border-radius: 1.5rem;
}
#kayna .rounded-\\[10px\\] {
  border-radius: 10px;
}
#kayna .rounded-\\[12px\\] {
  border-radius: 12px;
}
#kayna .rounded-\\[16px\\] {
  border-radius: 16px;
}
#kayna .rounded-\\[20px\\] {
  border-radius: 20px;
}
#kayna .rounded-\\[4px\\] {
  border-radius: 4px;
}
#kayna .rounded-\\[6px\\] {
  border-radius: 6px;
}
#kayna .rounded-\\[8px\\] {
  border-radius: 8px;
}
#kayna .rounded-full {
  border-radius: 9999px;
}
#kayna .rounded-lg {
  border-radius: 0.5rem;
}
#kayna .rounded-md {
  border-radius: 0.375rem;
}
#kayna .rounded-none {
  border-radius: 0px;
}
#kayna .rounded-xl {
  border-radius: 0.75rem;
}
#kayna .rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
#kayna .rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
#kayna .rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
#kayna .rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
#kayna .rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
#kayna .rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
#kayna .rounded-bl-\\[12px\\] {
  border-bottom-left-radius: 12px;
}
#kayna .rounded-br-\\[12px\\] {
  border-bottom-right-radius: 12px;
}
#kayna .rounded-tl-\\[12px\\] {
  border-top-left-radius: 12px;
}
#kayna .rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
#kayna .rounded-tr-\\[12px\\] {
  border-top-right-radius: 12px;
}
#kayna .rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
#kayna .border {
  border-width: 1px;
}
#kayna .border-2 {
  border-width: 2px;
}
#kayna .border-4 {
  border-width: 4px;
}
#kayna .border-\\[1px\\] {
  border-width: 1px;
}
#kayna .border-x-8 {
  border-left-width: 8px;
  border-right-width: 8px;
}
#kayna .border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
#kayna .border-b {
  border-bottom-width: 1px;
}
#kayna .border-b-2 {
  border-bottom-width: 2px;
}
#kayna .border-b-4 {
  border-bottom-width: 4px;
}
#kayna .border-b-8 {
  border-bottom-width: 8px;
}
#kayna .border-l-4 {
  border-left-width: 4px;
}
#kayna .border-r {
  border-right-width: 1px;
}
#kayna .border-r-4 {
  border-right-width: 4px;
}
#kayna .border-r-8 {
  border-right-width: 8px;
}
#kayna .border-t {
  border-top-width: 1px;
}
#kayna .border-t-2 {
  border-top-width: 2px;
}
#kayna .border-t-4 {
  border-top-width: 4px;
}
#kayna .border-solid {
  border-style: solid;
}
#kayna .border-dashed {
  border-style: dashed;
}
#kayna .border-dotted {
  border-style: dotted;
}
#kayna .\\!border-\\[\\#C8CEE3\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(200 206 227 / var(--tw-border-opacity, 1)) !important;
}
#kayna .border-\\[\\#15161E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(21 22 30 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#27A376\\] {
  --tw-border-opacity: 1;
  border-color: rgb(39 163 118 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#42D58E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(66 213 142 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#4886FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(72 134 255 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#6C70CC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(108 112 204 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#707EAE\\] {
  --tw-border-opacity: 1;
  border-color: rgb(112 126 174 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#808892\\] {
  --tw-border-opacity: 1;
  border-color: rgb(128 136 146 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#919CC2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(145 156 194 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#94A3B8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#A0AEC0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(160 174 192 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#C5C9CF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(197 201 207 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#C8CEE3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(200 206 227 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#D1E9E0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(209 233 224 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#D9D6FD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 214 253 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#DDDDDD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(221 221 221 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#E0E5F2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 229 242 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#E4E4E4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 228 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#E9E4FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 228 255 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#E9EDF7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 237 247 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#EA4335\\] {
  --tw-border-opacity: 1;
  border-color: rgb(234 67 53 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#F0F2F9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 242 249 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#F1E1D2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(241 225 210 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#F4F7FE\\] {
  --tw-border-opacity: 1;
  border-color: rgb(244 247 254 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#F8FAFE\\] {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 254 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#FD515E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(253 81 94 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#FF6B6B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 107 107 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#adb1b9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(173 177 185 / var(--tw-border-opacity, 1));
}
#kayna .border-\\[\\#ffde85\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 222 133 / var(--tw-border-opacity, 1));
}
#kayna .border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
#kayna .border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
#kayna .border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
#kayna .border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
#kayna .border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
#kayna .border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
#kayna .border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
#kayna .border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
#kayna .border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
#kayna .border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
#kayna .border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
#kayna .border-orange-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1));
}
#kayna .border-primary {
  border-color: var(--theme-primary);
}
#kayna .border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
#kayna .border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
#kayna .border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
#kayna .border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
#kayna .border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
#kayna .border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
#kayna .border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
#kayna .border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
#kayna .border-slate-600 {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
#kayna .border-transparent {
  border-color: transparent;
}
#kayna .border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
#kayna .border-l-gray-800 {
  --tw-border-opacity: 1;
  border-left-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
#kayna .border-r-gray-800 {
  --tw-border-opacity: 1;
  border-right-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
#kayna .border-r-transparent {
  border-right-color: transparent;
}
#kayna .border-t-primary {
  border-top-color: var(--theme-primary);
}
#kayna .bg-\\[\\#006400\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 100 0 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#11BDB0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 189 176 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#1C1F22\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 31 34 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#27A376\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(39 163 118 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#42D58E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(66 213 142 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#6366F1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#6C70CC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(108 112 204 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#707EAE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(112 126 174 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#808892\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(128 136 146 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#8241f1\\]\\/10 {
  background-color: rgb(130 65 241 / 0.1);
}
#kayna .bg-\\[\\#E0E5F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 229 242 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#E9EDF7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 237 247 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#EA4335\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 67 53 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#EB5E13\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 94 19 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#EEEDFE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 237 254 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#EEEEF0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 240 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#EEF2FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#EF4444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F0F0FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 254 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F0F4FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 244 255 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F1F9F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 249 246 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F3A449\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 164 73 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F5F3FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F5F7FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 247 250 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F8FAFE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 254 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#F9F9F9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 249 249 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FBD9D7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 217 215 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FBDFE0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 223 224 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FD515E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 81 94 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FDECEB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 236 235 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FDEFEF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 239 239 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FFE3CD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 227 205 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FFEDE0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 224 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FFF9F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 249 242 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#FFFDFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 253 252 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#b8b8b8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(184 184 184 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#bcc5de\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(188 197 222 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#efefef\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 239 239 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#f00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#f5f5f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
#kayna .bg-\\[\\#f5f8fa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 248 250 / var(--tw-bg-opacity, 1));
}
#kayna .bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
#kayna .bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
#kayna .bg-backgroundColor {
  background-color: var(--theme-bg-color);
}
#kayna .bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
#kayna .bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
#kayna .bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
#kayna .bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
#kayna .bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
#kayna .bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
#kayna .bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
#kayna .bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
#kayna .bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
#kayna .bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
#kayna .bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
#kayna .bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
#kayna .bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
#kayna .bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
#kayna .bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
#kayna .bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
#kayna .bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
#kayna .bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
#kayna .bg-primary {
  background-color: var(--theme-primary);
}
#kayna .bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
#kayna .bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
#kayna .bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
#kayna .bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
#kayna .bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
#kayna .bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
#kayna .bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
#kayna .bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
#kayna .bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
#kayna .bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
#kayna .bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
#kayna .bg-slate-50\\/80 {
  background-color: rgb(248 250 252 / 0.8);
}
#kayna .bg-slate-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
#kayna .bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
#kayna .bg-transparent {
  background-color: transparent;
}
#kayna .bg-violet-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / var(--tw-bg-opacity, 1));
}
#kayna .bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
#kayna .bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
#kayna .bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
#kayna .bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
#kayna .bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}
#kayna .fill-\\[\\#E9EDF7\\] {
  fill: #E9EDF7;
}
#kayna .fill-backgroundColor {
  fill: var(--theme-bg-color);
}
#kayna .fill-primary {
  fill: var(--theme-primary);
}
#kayna .fill-white {
  fill: #fff;
}
#kayna .stroke-\\[\\#E9EDF7\\] {
  stroke: #E9EDF7;
}
#kayna .stroke-primary {
  stroke: var(--theme-primary);
}
#kayna .object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
#kayna .object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
#kayna .p-0 {
  padding: 0px;
}
#kayna .p-1 {
  padding: 0.25rem;
}
#kayna .p-10 {
  padding: 2.5rem;
}
#kayna .p-2 {
  padding: 0.5rem;
}
#kayna .p-2\\.5 {
  padding: 0.625rem;
}
#kayna .p-3 {
  padding: 0.75rem;
}
#kayna .p-4 {
  padding: 1rem;
}
#kayna .p-5 {
  padding: 1.25rem;
}
#kayna .p-6 {
  padding: 1.5rem;
}
#kayna .p-8 {
  padding: 2rem;
}
#kayna .p-\\[2px\\] {
  padding: 2px;
}
#kayna .p-\\[8px\\] {
  padding: 8px;
}
#kayna .px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
#kayna .px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
#kayna .px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
#kayna .px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
#kayna .px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
#kayna .px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
#kayna .px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
#kayna .px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
#kayna .px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
#kayna .px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
#kayna .px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
#kayna .px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}
#kayna .py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
#kayna .py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
#kayna .py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
#kayna .py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
#kayna .py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
#kayna .py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
#kayna .py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
#kayna .py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
#kayna .py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
#kayna .py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
#kayna .py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
#kayna .py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
#kayna .py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
#kayna .py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
#kayna .py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
#kayna .py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
#kayna .pb-1 {
  padding-bottom: 0.25rem;
}
#kayna .pb-10 {
  padding-bottom: 2.5rem;
}
#kayna .pb-2 {
  padding-bottom: 0.5rem;
}
#kayna .pb-3 {
  padding-bottom: 0.75rem;
}
#kayna .pb-4 {
  padding-bottom: 1rem;
}
#kayna .pb-5 {
  padding-bottom: 1.25rem;
}
#kayna .pb-6 {
  padding-bottom: 1.5rem;
}
#kayna .pb-8 {
  padding-bottom: 2rem;
}
#kayna .pb-\\[8px\\] {
  padding-bottom: 8px;
}
#kayna .pl-4 {
  padding-left: 1rem;
}
#kayna .pl-5 {
  padding-left: 1.25rem;
}
#kayna .pl-6 {
  padding-left: 1.5rem;
}
#kayna .pl-7 {
  padding-left: 1.75rem;
}
#kayna .pr-1 {
  padding-right: 0.25rem;
}
#kayna .pr-2 {
  padding-right: 0.5rem;
}
#kayna .pr-4 {
  padding-right: 1rem;
}
#kayna .pt-1 {
  padding-top: 0.25rem;
}
#kayna .pt-14 {
  padding-top: 3.5rem;
}
#kayna .pt-16 {
  padding-top: 4rem;
}
#kayna .pt-2 {
  padding-top: 0.5rem;
}
#kayna .pt-3 {
  padding-top: 0.75rem;
}
#kayna .pt-4 {
  padding-top: 1rem;
}
#kayna .pt-5 {
  padding-top: 1.25rem;
}
#kayna .pt-6 {
  padding-top: 1.5rem;
}
#kayna .pt-8 {
  padding-top: 2rem;
}
#kayna .pt-\\[8px\\] {
  padding-top: 8px;
}
#kayna .text-left {
  text-align: left;
}
#kayna .text-center {
  text-align: center;
}
#kayna .text-right {
  text-align: right;
}
#kayna .align-middle {
  vertical-align: middle;
}
#kayna .font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
#kayna .font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
#kayna .text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
#kayna .text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
#kayna .text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
#kayna .text-\\[10px\\] {
  font-size: 10px;
}
#kayna .text-\\[11px\\] {
  font-size: 11px;
}
#kayna .text-\\[12px\\] {
  font-size: 12px;
}
#kayna .text-\\[13px\\] {
  font-size: 13px;
}
#kayna .text-\\[14px\\] {
  font-size: 14px;
}
#kayna .text-\\[15px\\] {
  font-size: 15px;
}
#kayna .text-\\[16px\\] {
  font-size: 16px;
}
#kayna .text-\\[18px\\] {
  font-size: 18px;
}
#kayna .text-\\[20px\\] {
  font-size: 20px;
}
#kayna .text-\\[22px\\] {
  font-size: 22px;
}
#kayna .text-\\[26px\\] {
  font-size: 26px;
}
#kayna .text-\\[28px\\] {
  font-size: 28px;
}
#kayna .text-\\[32px\\] {
  font-size: 32px;
}
#kayna .text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
#kayna .text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
#kayna .text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
#kayna .text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
#kayna .text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
#kayna .font-black {
  font-weight: 900;
}
#kayna .font-bold {
  font-weight: 700;
}
#kayna .font-extrabold {
  font-weight: 800;
}
#kayna .font-extralight {
  font-weight: 200;
}
#kayna .font-medium {
  font-weight: 500;
}
#kayna .font-normal {
  font-weight: 400;
}
#kayna .font-semibold {
  font-weight: 600;
}
#kayna .uppercase {
  text-transform: uppercase;
}
#kayna .capitalize {
  text-transform: capitalize;
}
#kayna .italic {
  font-style: italic;
}
#kayna .leading-4 {
  line-height: 1rem;
}
#kayna .leading-5 {
  line-height: 1.25rem;
}
#kayna .leading-6 {
  line-height: 1.5rem;
}
#kayna .leading-\\[1\\.6\\] {
  line-height: 1.6;
}
#kayna .leading-\\[16px\\] {
  line-height: 16px;
}
#kayna .leading-\\[17px\\] {
  line-height: 17px;
}
#kayna .leading-\\[26px\\] {
  line-height: 26px;
}
#kayna .leading-none {
  line-height: 1;
}
#kayna .leading-normal {
  line-height: 1.5;
}
#kayna .leading-relaxed {
  line-height: 1.625;
}
#kayna .leading-snug {
  line-height: 1.375;
}
#kayna .leading-tight {
  line-height: 1.25;
}
#kayna .tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
#kayna .tracking-wide {
  letter-spacing: 0.025em;
}
#kayna .tracking-wider {
  letter-spacing: 0.05em;
}
#kayna .tracking-widest {
  letter-spacing: 0.1em;
}
#kayna .\\!text-blue-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1)) !important;
}
#kayna .text-\\[\\#111827\\] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#11BDB0\\] {
  --tw-text-opacity: 1;
  color: rgb(17 189 176 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#15161E\\] {
  --tw-text-opacity: 1;
  color: rgb(21 22 30 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#1E293B\\] {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#1F1F1F\\] {
  --tw-text-opacity: 1;
  color: rgb(31 31 31 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#1F2751\\] {
  --tw-text-opacity: 1;
  color: rgb(31 39 81 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#202851\\] {
  --tw-text-opacity: 1;
  color: rgb(32 40 81 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#252846\\] {
  --tw-text-opacity: 1;
  color: rgb(37 40 70 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#27A376\\] {
  --tw-text-opacity: 1;
  color: rgb(39 163 118 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#374151\\] {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#3B4265\\] {
  --tw-text-opacity: 1;
  color: rgb(59 66 101 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#42D58E\\] {
  --tw-text-opacity: 1;
  color: rgb(66 213 142 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#475569\\] {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#4886FF\\] {
  --tw-text-opacity: 1;
  color: rgb(72 134 255 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#4d5766\\] {
  --tw-text-opacity: 1;
  color: rgb(77 87 102 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#534AB7\\] {
  --tw-text-opacity: 1;
  color: rgb(83 74 183 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#5F5F5F\\] {
  --tw-text-opacity: 1;
  color: rgb(95 95 95 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#6768EE\\] {
  --tw-text-opacity: 1;
  color: rgb(103 104 238 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#6A717D\\] {
  --tw-text-opacity: 1;
  color: rgb(106 113 125 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#6B7280\\] {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#707EAE\\] {
  --tw-text-opacity: 1;
  color: rgb(112 126 174 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#7C3AED\\] {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#7e8084\\] {
  --tw-text-opacity: 1;
  color: rgb(126 128 132 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#808892\\] {
  --tw-text-opacity: 1;
  color: rgb(128 136 146 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#919CC2\\] {
  --tw-text-opacity: 1;
  color: rgb(145 156 194 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#94A3B8\\] {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#9CA3AF\\] {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#9E0085\\] {
  --tw-text-opacity: 1;
  color: rgb(158 0 133 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#A0AEC0\\] {
  --tw-text-opacity: 1;
  color: rgb(160 174 192 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#A5A9B9\\] {
  --tw-text-opacity: 1;
  color: rgb(165 169 185 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#C8CEE3\\] {
  --tw-text-opacity: 1;
  color: rgb(200 206 227 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#D95F27\\] {
  --tw-text-opacity: 1;
  color: rgb(217 95 39 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#E9EDF7\\] {
  --tw-text-opacity: 1;
  color: rgb(233 237 247 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#EA4335\\] {
  --tw-text-opacity: 1;
  color: rgb(234 67 53 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#EE7E82\\] {
  --tw-text-opacity: 1;
  color: rgb(238 126 130 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#EEEDFE\\] {
  --tw-text-opacity: 1;
  color: rgb(238 237 254 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#FD515E\\] {
  --tw-text-opacity: 1;
  color: rgb(253 81 94 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#FF6B6B\\] {
  --tw-text-opacity: 1;
  color: rgb(255 107 107 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#b18aca\\] {
  --tw-text-opacity: 1;
  color: rgb(177 138 202 / var(--tw-text-opacity, 1));
}
#kayna .text-\\[\\#ffde85\\] {
  --tw-text-opacity: 1;
  color: rgb(255 222 133 / var(--tw-text-opacity, 1));
}
#kayna .text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
#kayna .text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
#kayna .text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
#kayna .text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
#kayna .text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
#kayna .text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
#kayna .text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
#kayna .text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
#kayna .text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
#kayna .text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
#kayna .text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
#kayna .text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
#kayna .text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
#kayna .text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
#kayna .text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
#kayna .text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
#kayna .text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
#kayna .text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
#kayna .text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
#kayna .text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
#kayna .text-primary {
  color: var(--theme-primary);
}
#kayna .text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
#kayna .text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
#kayna .text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
#kayna .text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
#kayna .text-secondary {
  color: var(--theme-secondary);
}
#kayna .text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
#kayna .text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
#kayna .text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
#kayna .text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
#kayna .text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
#kayna .text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
#kayna .text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
#kayna .text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
#kayna .text-textColor {
  color: var(--theme-text-color);
}
#kayna .text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
#kayna .text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
#kayna .\\!underline {
  text-decoration-line: underline !important;
}
#kayna .underline {
  text-decoration-line: underline;
}
#kayna .decoration-primary {
  text-decoration-color: var(--theme-primary);
}
#kayna .decoration-white {
  text-decoration-color: #fff;
}
#kayna .decoration-2 {
  text-decoration-thickness: 2px;
}
#kayna .underline-offset-4 {
  text-underline-offset: 4px;
}
#kayna .antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#kayna .placeholder-\\[\\#707EAE\\]::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(112 126 174 / var(--tw-placeholder-opacity, 1));
}
#kayna .placeholder-\\[\\#707EAE\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(112 126 174 / var(--tw-placeholder-opacity, 1));
}
#kayna .placeholder-\\[\\#EA4335\\]::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(234 67 53 / var(--tw-placeholder-opacity, 1));
}
#kayna .placeholder-\\[\\#EA4335\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(234 67 53 / var(--tw-placeholder-opacity, 1));
}
#kayna .placeholder-\\[\\#b0b7bf\\]::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(176 183 191 / var(--tw-placeholder-opacity, 1));
}
#kayna .placeholder-\\[\\#b0b7bf\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(176 183 191 / var(--tw-placeholder-opacity, 1));
}
#kayna .placeholder-gray-500::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
#kayna .placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
#kayna .accent-primary {
  accent-color: var(--theme-primary);
}
#kayna .opacity-0 {
  opacity: 0;
}
#kayna .opacity-10 {
  opacity: 0.1;
}
#kayna .opacity-100 {
  opacity: 1;
}
#kayna .opacity-20 {
  opacity: 0.2;
}
#kayna .opacity-25 {
  opacity: 0.25;
}
#kayna .opacity-30 {
  opacity: 0.3;
}
#kayna .opacity-50 {
  opacity: 0.5;
}
#kayna .opacity-60 {
  opacity: 0.6;
}
#kayna .opacity-70 {
  opacity: 0.7;
}
#kayna .opacity-75 {
  opacity: 0.75;
}
#kayna .opacity-80 {
  opacity: 0.8;
}
#kayna .shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#kayna .shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#kayna .shadow-\\[0_4px_12px_0px_\\#1F27510D\\] {
  --tw-shadow: 0 4px 12px 0px #1F27510D;
  --tw-shadow-colored: 0 4px 12px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#kayna .shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#kayna .shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
#kayna .outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
#kayna .outline {
  outline-style: solid;
}
#kayna .ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
#kayna .ring-red-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
#kayna .ring-offset-0 {
  --tw-ring-offset-width: 0px;
}
#kayna .blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#kayna .grayscale-\\[0\\.5\\] {
  --tw-grayscale: grayscale(0.5);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#kayna .filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
#kayna .backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
#kayna .transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#kayna .transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#kayna .transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#kayna .transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
#kayna .delay-\\[50ms\\] {
  transition-delay: 50ms;
}
#kayna .duration-1000 {
  transition-duration: 1000ms;
}
#kayna .duration-150 {
  transition-duration: 150ms;
}
#kayna .duration-200 {
  transition-duration: 200ms;
}
#kayna .duration-300 {
  transition-duration: 300ms;
}
#kayna .duration-500 {
  transition-duration: 500ms;
}
#kayna .duration-700 {
  transition-duration: 700ms;
}
#kayna .ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
#kayna .ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
#kayna .ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.kayna-app {
  font-family: 'Montserrat', sans-serif;
}

.ripple {
  background-position: center;
  transition: background 0.8s;
}
.ripple:hover {
  background: #e2e0e0 radial-gradient(circle, transparent 1%, #e2e0e0 1%)
    center/15000%;
}
.ripple:active {
  background-color: #b6b6b6;
  background-size: 100%;
  transition: background 0s;
}

.rippleNight {
  background-position: center;
  transition: background 0.8s;
}
.rippleNight:hover {
  background: #e2e0e0 radial-gradient(circle, transparent 1%, #e2e0e0 1%)
    center/15000%;
}
.rippleNight:active {
  background-color: #b6b6b6;
  background-size: 100%;
  transition: background 0s;
}

/* .rippleNight {
  background-position: center;
  transition: background 0.8s;
}
.rippleNight:hover {
  background: rgb(25, 28, 32)
    radial-gradient(circle, transparent 1%, rgb(25, 28, 32) 1%) center/15000%;
}
.rippleNight:active {
  background-color: #090a0b;
  background-size: 100%;
  transition: background 0s;
} */

.mainSecImg {
  width: 12%;
}
.tabsWidth {
  width: 100%;
  cursor: pointer;
}
.commonHeight {
  height: auto;
}
.getInsuredImg {
  height: 4rem;
  width: 4rem;
}

.loader {
  width: 120px; /* the size */
  padding: 15px; /* the border thickness */
  background: var(--theme-primary); /* the color */

  aspect-ratio: 1;
  border-radius: 50%;
  --_m: conic-gradient(#0000, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  box-sizing: border-box;
  animation: load 1s linear infinite;
}

@keyframes load {
  to {
    transform: rotate(1turn);
  }
}

/* iframe {
  display: none !important;
} */

.kayna-app div::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

.kayna-app div::-webkit-scrollbar-thumb {
  background-color: var(--theme-primary);
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}

.kayna-app .briza-collect-form .briza-field-container .briza-field iframe {
  height: 100%;
  vertical-align: middle;
  width: 100%;
}

.react-datepicker-popper,
.react-datepicker {
  z-index: 55 !important;
}

.rich-text ul {
  list-style-type: disc;
  margin-left: 20px;
  text-align: left;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: var(--theme-primary);
  border-radius: 3px;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* it will hide autofill user icon on safari */
input::-webkit-contacts-auto-fill-button,
input::-webkit-credentials-auto-fill-button {
  visibility: hidden !important;
  display: none !important;
  pointer-events: none !important;
  position: absolute !important;
  right: 0 !important;
}

.sectionBanner:has(.unified-kwant) {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0.2rem 0;
}

.sectionBanner:has(.unified-kwant) > div {
  max-width: 48rem;
  margin: 0 auto;
}

@media (max-width: 385px) {
  .react-datepicker {
    margin-top: 90%;
  }
}

@media (min-width: 386px) and (max-width: 766px) {
  .react-datepicker {
    margin-top: 50%;
  }
}

/* Mobile form readability tweaks */
@media (max-width: 767px) {
  /* Ensure long field labels and helper texts wrap without overlap */
  #form-container label,
  #form-container .rich-text,
  #form-container .briza-field-container > span,
  #form-container .field-label {
    font-size: 0.875rem; /* 14px */
    line-height: 1.25; /* ~20px */
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  /* Consistent touch size and avoid iOS zoom */
  #form-container input[type='text'],
  #form-container input[type='email'],
  #form-container input[type='url'],
  #form-container input[type='number'],
  #form-container input[type='tel'],
  #form-container select,
  #form-container textarea {
    height: 52px;
    font-size: 16px;
  }
}

/* Toast notification animations */
@keyframes slide-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.animate-slide-in {
  animation: slide-in 0.3s ease-out;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

#kayna :is(.marker\\:text-primary *)::marker {
  color: var(--theme-primary);
}

#kayna :is(.marker\\:text-slate-900 *)::marker {
  color: rgb(15 23 42 );
}

#kayna .marker\\:text-primary::marker {
  color: var(--theme-primary);
}

#kayna .marker\\:text-slate-900::marker {
  color: rgb(15 23 42 );
}

#kayna .after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

#kayna .after\\:start-\\[2px\\]::after {
  content: var(--tw-content);
  inset-inline-start: 2px;
}

#kayna .after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}

#kayna .after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

#kayna .after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

#kayna .after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

#kayna .after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

#kayna .after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

#kayna .after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

#kayna .last\\:mb-0:last-child {
  margin-bottom: 0px;
}

#kayna .last\\:mr-0:last-child {
  margin-right: 0px;
}

#kayna .hover\\:border-\\[\\#4F46E5\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}

#kayna .hover\\:border-amber-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}

#kayna .hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

#kayna .hover\\:border-blue-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

#kayna .hover\\:border-primary:hover {
  border-color: var(--theme-primary);
}

#kayna .hover\\:border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#42D58E\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(66 213 142 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#4886FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(72 134 255 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#5A5EAF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 94 175 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#7f35b2\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(127 53 178 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#A0AEC0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(160 174 192 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#D44D0B\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(212 77 11 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#E6EBF9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 235 249 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#FD515E\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 81 94 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#FF6B6B\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 107 107 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-\\[\\#ffde85\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 222 133 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-primary:hover {
  background-color: var(--theme-primary);
}

#kayna .hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

#kayna .hover\\:text-\\[\\#4F46E5\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-primary:hover {
  color: var(--theme-primary);
}

#kayna .hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-slate-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-violet-900:hover {
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

#kayna .hover\\:underline:hover {
  text-decoration-line: underline;
}

#kayna .hover\\:opacity-100:hover {
  opacity: 1;
}

#kayna .hover\\:opacity-75:hover {
  opacity: 0.75;
}

#kayna .hover\\:opacity-90:hover {
  opacity: 0.9;
}

#kayna .hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

#kayna .hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

#kayna .focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

#kayna .focus\\:bg-gray-200:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

#kayna .focus\\:accent-primary:focus {
  accent-color: var(--theme-primary);
}

#kayna .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

#kayna .focus\\:outline-primary:focus {
  outline-color: var(--theme-primary);
}

#kayna .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

#kayna .focus\\:ring-primary:focus {
  --tw-ring-color: var(--theme-primary);
}

#kayna .focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

#kayna .active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

#kayna .active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

#kayna .active\\:bg-gray-200:active {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

#kayna .enabled\\:hover\\:bg-primary:hover:enabled {
  background-color: var(--theme-primary);
}

#kayna .enabled\\:hover\\:text-white:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

#kayna .disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

#kayna .disabled\\:border-\\[\\#FBDFE0\\]:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(251 223 224 / var(--tw-border-opacity, 1));
}

#kayna .disabled\\:bg-\\[\\#FBDFE0\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(251 223 224 / var(--tw-bg-opacity, 1));
}

#kayna .disabled\\:bg-blue-300:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}

#kayna .disabled\\:bg-green-300:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity, 1));
}

#kayna .disabled\\:text-\\[\\#EE7E82\\]:disabled {
  --tw-text-opacity: 1;
  color: rgb(238 126 130 / var(--tw-text-opacity, 1));
}

#kayna .disabled\\:text-gray-300:disabled {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

#kayna .disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

#kayna .disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

#kayna .disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

#kayna :is(.group:hover .group-hover\\:block) {
  display: block;
}

#kayna :is(.group:hover .group-hover\\:scale-110) {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

#kayna :is(.group:hover .group-hover\\:text-yellow-500) {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}

#kayna :is(.group:hover .group-hover\\:opacity-100) {
  opacity: 1;
}

#kayna :is(.peer:checked ~ .peer-checked\\:translate-x-6) {
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

#kayna :is(.peer:checked ~ .peer-checked\\:border-\\[6px\\]) {
  border-width: 6px;
}

#kayna :is(.peer:checked ~ .peer-checked\\:border-primary) {
  border-color: var(--theme-primary);
}

#kayna :is(.peer:checked ~ .peer-checked\\:bg-\\[\\#15161E\\]) {
  --tw-bg-opacity: 1;
  background-color: rgb(21 22 30 / var(--tw-bg-opacity, 1));
}

#kayna :is(.peer:checked ~ .peer-checked\\:bg-primary) {
  background-color: var(--theme-primary);
}

#kayna :is(.peer:checked ~ .peer-checked\\:after\\:translate-x-full)::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

#kayna :is(.peer:checked ~ .peer-checked\\:after\\:border-white)::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

#kayna :is(.peer:checked ~ .group .peer-checked\\:group-\\[\\]\\:flex) {
  display: flex;
}

#kayna :is(.peer:checked ~ .group .peer-checked\\:group-\\[\\]\\:border-8) {
  border-width: 8px;
}

#kayna :is(.peer:checked ~ .group .peer-checked\\:group-\\[\\]\\:border-primary) {
  border-color: var(--theme-primary);
}

#kayna :is(.peer:focus ~ .peer-focus\\:outline-none) {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@media (min-width: 640px) {

  #kayna .sm\\:bottom-\\[calc\\(100\\%\\+4px\\)\\] {
    bottom: calc(100% + 4px);
  }

  #kayna .sm\\:top-\\[unset\\] {
    top: unset;
  }

  #kayna .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  #kayna .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  #kayna .sm\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  #kayna .sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  #kayna .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  #kayna .sm\\:ml-0 {
    margin-left: 0px;
  }

  #kayna .sm\\:mr-0 {
    margin-right: 0px;
  }

  #kayna .sm\\:mr-auto {
    margin-right: auto;
  }

  #kayna .sm\\:mt-0 {
    margin-top: 0px;
  }

  #kayna .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  #kayna .sm\\:mt-8 {
    margin-top: 2rem;
  }

  #kayna .sm\\:block {
    display: block;
  }

  #kayna .sm\\:flex {
    display: flex;
  }

  #kayna .sm\\:hidden {
    display: none;
  }

  #kayna .sm\\:size-5 {
    width: 1.25rem;
    height: 1.25rem;
  }

  #kayna .sm\\:size-6 {
    width: 1.5rem;
    height: 1.5rem;
  }

  #kayna .sm\\:h-\\[95\\%\\] {
    height: 95%;
  }

  #kayna .sm\\:h-\\[95vh\\] {
    height: 95vh;
  }

  #kayna .sm\\:w-\\[95vw\\] {
    width: 95vw;
  }

  #kayna .sm\\:w-auto {
    width: auto;
  }

  #kayna .sm\\:w-full {
    width: 100%;
  }

  #kayna .sm\\:min-w-\\[110px\\] {
    min-width: 110px;
  }

  #kayna .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #kayna .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  #kayna .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  #kayna .sm\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  #kayna .sm\\:flex-row {
    flex-direction: row;
  }

  #kayna .sm\\:items-center {
    align-items: center;
  }

  #kayna .sm\\:items-stretch {
    align-items: stretch;
  }

  #kayna .sm\\:justify-start {
    justify-content: flex-start;
  }

  #kayna .sm\\:justify-center {
    justify-content: center;
  }

  #kayna .sm\\:justify-between {
    justify-content: space-between;
  }

  #kayna .sm\\:justify-around {
    justify-content: space-around;
  }

  #kayna .sm\\:gap-2 {
    gap: 0.5rem;
  }

  #kayna .sm\\:gap-3 {
    gap: 0.75rem;
  }

  #kayna .sm\\:gap-4 {
    gap: 1rem;
  }

  #kayna .sm\\:gap-x-1 {
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
  }

  #kayna .sm\\:gap-x-2 {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  #kayna .sm\\:gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  #kayna .sm\\:gap-y-0 {
    row-gap: 0px;
  }

  #kayna .sm\\:gap-y-2 {
    row-gap: 0.5rem;
  }

  #kayna .sm\\:gap-y-3 {
    row-gap: 0.75rem;
  }

  #kayna :is(.sm\\:divide-x-2 > :not([hidden]) ~ :not([hidden])) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(2px * var(--tw-divide-x-reverse));
    border-left-width: calc(2px * calc(1 - var(--tw-divide-x-reverse)));
  }

  #kayna :is(.sm\\:divide-y-0 > :not([hidden]) ~ :not([hidden])) {
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  #kayna :is(.sm\\:divide-none > :not([hidden]) ~ :not([hidden])) {
    border-style: none;
  }

  #kayna .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  #kayna .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }

  #kayna .sm\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  #kayna .sm\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  #kayna .sm\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  #kayna .sm\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  #kayna .sm\\:p-4 {
    padding: 1rem;
  }

  #kayna .sm\\:p-5 {
    padding: 1.25rem;
  }

  #kayna .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  #kayna .sm\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  #kayna .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  #kayna .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  #kayna .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  #kayna .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  #kayna .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  #kayna .sm\\:pl-7 {
    padding-left: 1.75rem;
  }

  #kayna .sm\\:pl-\\[4\\.3rem\\] {
    padding-left: 4.3rem;
  }

  #kayna .sm\\:pt-\\[2\\.5vh\\] {
    padding-top: 2.5vh;
  }

  #kayna .sm\\:text-right {
    text-align: right;
  }

  #kayna .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  #kayna .sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  #kayna .sm\\:text-\\[32px\\] {
    font-size: 32px;
  }

  #kayna .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  #kayna .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  #kayna .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  #kayna .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  #kayna .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {

  #kayna .md\\:absolute {
    position: absolute;
  }

  #kayna .md\\:top-0 {
    top: 0px;
  }

  #kayna .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  #kayna .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  #kayna .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  #kayna .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  #kayna .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  #kayna .md\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  #kayna .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  #kayna .md\\:-ml-4 {
    margin-left: -1rem;
  }

  #kayna .md\\:mb-0 {
    margin-bottom: 0px;
  }

  #kayna .md\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  #kayna .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  #kayna .md\\:ml-auto {
    margin-left: auto;
  }

  #kayna .md\\:mr-2 {
    margin-right: 0.5rem;
  }

  #kayna .md\\:mt-0 {
    margin-top: 0px;
  }

  #kayna .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  #kayna .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  #kayna .md\\:flex {
    display: flex;
  }

  #kayna .md\\:grid {
    display: grid;
  }

  #kayna .md\\:size-5 {
    width: 1.25rem;
    height: 1.25rem;
  }

  #kayna .md\\:h-10 {
    height: 2.5rem;
  }

  #kayna .md\\:h-20 {
    height: 5rem;
  }

  #kayna .md\\:h-3 {
    height: 0.75rem;
  }

  #kayna .md\\:h-5 {
    height: 1.25rem;
  }

  #kayna .md\\:h-6 {
    height: 1.5rem;
  }

  #kayna .md\\:h-8 {
    height: 2rem;
  }

  #kayna .md\\:h-\\[56px\\] {
    height: 56px;
  }

  #kayna .md\\:h-\\[60px\\] {
    height: 60px;
  }

  #kayna .md\\:h-\\[calc\\(100vh-140px\\)\\] {
    height: calc(100vh - 140px);
  }

  #kayna .md\\:min-h-\\[58px\\] {
    min-height: 58px;
  }

  #kayna .md\\:min-h-\\[60px\\] {
    min-height: 60px;
  }

  #kayna .md\\:w-10 {
    width: 2.5rem;
  }

  #kayna .md\\:w-20 {
    width: 5rem;
  }

  #kayna .md\\:w-3 {
    width: 0.75rem;
  }

  #kayna .md\\:w-4\\/6 {
    width: 66.666667%;
  }

  #kayna .md\\:w-5 {
    width: 1.25rem;
  }

  #kayna .md\\:w-6 {
    width: 1.5rem;
  }

  #kayna .md\\:w-8 {
    width: 2rem;
  }

  #kayna .md\\:w-\\[50vw\\] {
    width: 50vw;
  }

  #kayna .md\\:w-\\[calc\\(100vw-104px\\)\\] {
    width: calc(100vw - 104px);
  }

  #kayna .md\\:w-auto {
    width: auto;
  }

  #kayna .md\\:w-full {
    width: 100%;
  }

  #kayna .md\\:min-w-\\[120px\\] {
    min-width: 120px;
  }

  #kayna .md\\:min-w-\\[144px\\] {
    min-width: 144px;
  }

  #kayna .md\\:min-w-max {
    min-width: -moz-max-content;
    min-width: max-content;
  }

  #kayna .md\\:max-w-\\[100px\\] {
    max-width: 100px;
  }

  #kayna .md\\:max-w-\\[250px\\] {
    max-width: 250px;
  }

  #kayna .md\\:max-w-\\[50vw\\] {
    max-width: 50vw;
  }

  #kayna .md\\:max-w-none {
    max-width: none;
  }

  #kayna .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  #kayna .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #kayna .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  #kayna .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  #kayna .md\\:flex-row {
    flex-direction: row;
  }

  #kayna .md\\:items-end {
    align-items: flex-end;
  }

  #kayna .md\\:items-center {
    align-items: center;
  }

  #kayna .md\\:justify-between {
    justify-content: space-between;
  }

  #kayna .md\\:gap-4 {
    gap: 1rem;
  }

  #kayna .md\\:gap-6 {
    gap: 1.5rem;
  }

  #kayna .md\\:gap-x-6 {
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }

  #kayna .md\\:gap-y-8 {
    row-gap: 2rem;
  }

  #kayna .md\\:self-auto {
    align-self: auto;
  }

  #kayna .md\\:whitespace-nowrap {
    white-space: nowrap;
  }

  #kayna .md\\:rounded-\\[12px\\] {
    border-radius: 12px;
  }

  #kayna .md\\:rounded-\\[16px\\] {
    border-radius: 16px;
  }

  #kayna .md\\:rounded-xl {
    border-radius: 0.75rem;
  }

  #kayna .md\\:border-l {
    border-left-width: 1px;
  }

  #kayna .md\\:border-t-0 {
    border-top-width: 0px;
  }

  #kayna .md\\:p-4 {
    padding: 1rem;
  }

  #kayna .md\\:p-5 {
    padding: 1.25rem;
  }

  #kayna .md\\:p-6 {
    padding: 1.5rem;
  }

  #kayna .md\\:p-8 {
    padding: 2rem;
  }

  #kayna .md\\:p-\\[20px\\] {
    padding: 20px;
  }

  #kayna .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  #kayna .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  #kayna .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  #kayna .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  #kayna .md\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  #kayna .md\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  #kayna .md\\:pl-\\[65px\\] {
    padding-left: 65px;
  }

  #kayna .md\\:pt-10 {
    padding-top: 2.5rem;
  }

  #kayna .md\\:pt-4 {
    padding-top: 1rem;
  }

  #kayna .md\\:pt-8 {
    padding-top: 2rem;
  }

  #kayna .md\\:text-left {
    text-align: left;
  }

  #kayna .md\\:text-right {
    text-align: right;
  }

  #kayna .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  #kayna .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  #kayna .md\\:text-\\[22px\\] {
    font-size: 22px;
  }

  #kayna .md\\:text-\\[32px\\] {
    font-size: 32px;
  }

  #kayna .md\\:text-\\[40px\\] {
    font-size: 40px;
  }

  #kayna .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  #kayna .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  #kayna .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  #kayna .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  #kayna .md\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  #kayna .md\\:leading-normal {
    line-height: 1.5;
  }
}

@media (min-width: 1024px) {

  #kayna .lg\\:ml-4 {
    margin-left: 1rem;
  }

  #kayna .lg\\:mr-auto {
    margin-right: auto;
  }

  #kayna .lg\\:hidden {
    display: none;
  }

  #kayna .lg\\:h-full {
    height: 100%;
  }

  #kayna .lg\\:w-1\\/2 {
    width: 50%;
  }

  #kayna .lg\\:w-\\[360px\\] {
    width: 360px;
  }

  #kayna .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  #kayna .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  #kayna .lg\\:flex-row {
    flex-direction: row;
  }

  #kayna .lg\\:items-end {
    align-items: flex-end;
  }

  #kayna .lg\\:justify-center {
    justify-content: center;
  }

  #kayna .lg\\:justify-between {
    justify-content: space-between;
  }

  #kayna .lg\\:pr-10 {
    padding-right: 2.5rem;
  }

  #kayna .lg\\:pt-8 {
    padding-top: 2rem;
  }

  #kayna .lg\\:text-center {
    text-align: center;
  }

  #kayna .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  #kayna .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  #kayna .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  #kayna .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1280px) {

  #kayna .xl\\:w-\\[280px\\] {
    width: 280px;
  }

  #kayna .xl\\:w-auto {
    width: auto;
  }

  #kayna .xl\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  #kayna .xl\\:flex-row {
    flex-direction: row;
  }

  #kayna .xl\\:items-center {
    align-items: center;
  }

  #kayna .xl\\:gap-10 {
    gap: 2.5rem;
  }

  #kayna .xl\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  #kayna .xl\\:text-left {
    text-align: left;
  }

  #kayna .xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (prefers-color-scheme: dark) {

  #kayna .dark\\:bg-\\[\\#E9EDF7\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(233 237 247 / var(--tw-bg-opacity, 1));
  }

  #kayna .dark\\:text-orange-400 {
    --tw-text-opacity: 1;
    color: rgb(251 146 60 / var(--tw-text-opacity, 1));
  }
}

#kayna .\\[\\&\\:not\\(\\:last-child\\)\\]\\:mb-5:not(:last-child) {
  margin-bottom: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B,CAA1B;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gBAA0B,EAA1B,MAA0B;EAA1B,cAA0B;KAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAC1B;EAAA;AAAgC;AAAhC;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAChC;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,WAA+B;EAA/B;AAA+B;AAA/B;EAAA,cAA+B;EAA/B;AAA+B;AAA/B;EAAA,WAA+B;EAA/B;AAA+B;AAA/B;EAAA,WAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,2BAA+B;IAA/B;EAA+B;;EAA/B;IAAA,eAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;;EAA/B;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yBAA+B;KAA/B,sBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;KAA/B,qBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wBAA+B;OAA/B;AAA+B;AAA/B;EAAA,yBAA+B;OAA/B;AAA+B;AAA/B;EAAA,uBAA+B;OAA/B;AAA+B;AAA/B;EAAA,wBAA+B;OAA/B;AAA+B;AAA/B;EAAA,qBAA+B;OAA/B;AAA+B;AAA/B;EAAA,uBAA+B;OAA/B;AAA+B;AAA/B;EAAA,qBAA+B;OAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;KAA/B;AAA+B;AAA/B;EAAA,oBAA+B;KAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,8FAA+B;EAA/B;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,qCAA+B;EAA/B,0DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;;AAI/B;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE;iBACe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE;iBACe;AACjB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,aAAa,EAAE,yBAAyB;EACxC,gCAAgC,EAAE,cAAc;;EAEhD,eAAe;EACf,kBAAkB;EAClB,wEAAwE;EACxE,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,wBAAwB;EACxB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC;;;;;;;;;GASC;AACH;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,8CAA8C;AAC9C;;EAEE,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE,mEAAmE;EACnE;;;;IAIE,mBAAmB,EAAE,SAAS;IAC9B,iBAAiB,EAAE,UAAU;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,6CAA6C;EAC7C;;;;;;;IAOE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AA1OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA,wBA2OA;EA3OA,wDA2OA;EA3OA;AA2OA;;AA3OA;EAAA,gBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,+EA2OA;EA3OA,mGA2OA;EA3OA;AA2OA;;AA3OA;EAAA,6EA2OA;EA3OA,iGA2OA;EA3OA;AA2OA;;AA3OA;EAAA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,8BA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,2GA2OA;EA3OA,yGA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,iBA2OA;EA3OA,iBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,iBA2OA;EA3OA,iBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,oBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,wBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,kBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA,0BA2OA;EA3OA,sBA2OA;EA3OA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA;AA2OA;;AA3OA;EAAA,8BA2OA;EA3OA;AA2OA;;AA3OA;;EAAA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,iBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,cA2OA;IA3OA;EA2OA;;EA3OA;IAAA,aA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,wBA2OA;SA3OA;EA2OA;;EA3OA;IAAA,uBA2OA;SA3OA;EA2OA;;EA3OA;IAAA,qBA2OA;SA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,wBA2OA;IA3OA,0DA2OA;IA3OA;EA2OA;;EA3OA;IAAA,wBA2OA;IA3OA,kEA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,+BA2OA;IA3OA;EA2OA;;EA3OA;IAAA,4BA2OA;IA3OA;EA2OA;;EA3OA;IAAA,+BA2OA;IA3OA;EA2OA;;EA3OA;IAAA,6BA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,iBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,qBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,qBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,oBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,eA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;AAAA;;AA3OA;;EAAA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,gBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,cA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,2BA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,uBA2OA;SA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,iBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,qBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,oBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,qBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,oBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,iBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,eA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;AAAA;;AA3OA;;EAAA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,eA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,mBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;AAAA;;AA3OA;;EAAA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,oBA2OA;IA3OA;EA2OA;;EA3OA;IAAA;EA2OA;;EA3OA;IAAA,kBA2OA;IA3OA;EA2OA;AAAA;;AA3OA;;EAAA;IAAA,kBA2OA;IA3OA;EA2OA;;EA3OA;IAAA,oBA2OA;IA3OA;EA2OA;AAAA;;AA3OA;EAAA;AA2OA","sourcesContent":["@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n.kayna-app {\n  font-family: 'Montserrat', sans-serif;\n}\n\n.ripple {\n  background-position: center;\n  transition: background 0.8s;\n}\n.ripple:hover {\n  background: #e2e0e0 radial-gradient(circle, transparent 1%, #e2e0e0 1%)\n    center/15000%;\n}\n.ripple:active {\n  background-color: #b6b6b6;\n  background-size: 100%;\n  transition: background 0s;\n}\n\n.rippleNight {\n  background-position: center;\n  transition: background 0.8s;\n}\n.rippleNight:hover {\n  background: #e2e0e0 radial-gradient(circle, transparent 1%, #e2e0e0 1%)\n    center/15000%;\n}\n.rippleNight:active {\n  background-color: #b6b6b6;\n  background-size: 100%;\n  transition: background 0s;\n}\n\n/* .rippleNight {\n  background-position: center;\n  transition: background 0.8s;\n}\n.rippleNight:hover {\n  background: rgb(25, 28, 32)\n    radial-gradient(circle, transparent 1%, rgb(25, 28, 32) 1%) center/15000%;\n}\n.rippleNight:active {\n  background-color: #090a0b;\n  background-size: 100%;\n  transition: background 0s;\n} */\n\n.mainSecImg {\n  width: 12%;\n}\n.tabsWidth {\n  width: 100%;\n  cursor: pointer;\n}\n.commonHeight {\n  height: auto;\n}\n.getInsuredImg {\n  height: 4rem;\n  width: 4rem;\n}\n\n.loader {\n  width: 120px; /* the size */\n  padding: 15px; /* the border thickness */\n  background: var(--theme-primary); /* the color */\n\n  aspect-ratio: 1;\n  border-radius: 50%;\n  --_m: conic-gradient(#0000, #000), linear-gradient(#000 0 0) content-box;\n  -webkit-mask: var(--_m);\n  mask: var(--_m);\n  -webkit-mask-composite: source-out;\n  mask-composite: subtract;\n  box-sizing: border-box;\n  animation: load 1s linear infinite;\n}\n\n@keyframes load {\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* iframe {\n  display: none !important;\n} */\n\n.kayna-app div::-webkit-scrollbar {\n  width: 5px;\n  background-color: #f5f5f5;\n}\n\n.kayna-app div::-webkit-scrollbar-thumb {\n  background-color: var(--theme-primary);\n  background-image: -webkit-linear-gradient(\n    45deg,\n    rgba(255, 255, 255, 0.2) 25%,\n    transparent 25%,\n    transparent 50%,\n    rgba(255, 255, 255, 0.2) 50%,\n    rgba(255, 255, 255, 0.2) 75%,\n    transparent 75%,\n    transparent\n  );\n}\n\n.kayna-app .briza-collect-form .briza-field-container .briza-field iframe {\n  height: 100%;\n  vertical-align: middle;\n  width: 100%;\n}\n\n.react-datepicker-popper,\n.react-datepicker {\n  z-index: 55 !important;\n}\n\n.rich-text ul {\n  list-style-type: disc;\n  margin-left: 20px;\n  text-align: left;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: var(--theme-primary);\n  border-radius: 3px;\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n/* it will hide autofill user icon on safari */\ninput::-webkit-contacts-auto-fill-button,\ninput::-webkit-credentials-auto-fill-button {\n  visibility: hidden !important;\n  display: none !important;\n  pointer-events: none !important;\n  position: absolute !important;\n  right: 0 !important;\n}\n\n.sectionBanner:has(.unified-kwant) {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin: 0.2rem 0;\n}\n\n.sectionBanner:has(.unified-kwant) > div {\n  max-width: 48rem;\n  margin: 0 auto;\n}\n\n@media (max-width: 385px) {\n  .react-datepicker {\n    margin-top: 90%;\n  }\n}\n\n@media (min-width: 386px) and (max-width: 766px) {\n  .react-datepicker {\n    margin-top: 50%;\n  }\n}\n\n/* Mobile form readability tweaks */\n@media (max-width: 767px) {\n  /* Ensure long field labels and helper texts wrap without overlap */\n  #form-container label,\n  #form-container .rich-text,\n  #form-container .briza-field-container > span,\n  #form-container .field-label {\n    font-size: 0.875rem; /* 14px */\n    line-height: 1.25; /* ~20px */\n    word-break: break-word;\n    overflow-wrap: anywhere;\n    white-space: normal;\n  }\n\n  /* Consistent touch size and avoid iOS zoom */\n  #form-container input[type='text'],\n  #form-container input[type='email'],\n  #form-container input[type='url'],\n  #form-container input[type='number'],\n  #form-container input[type='tel'],\n  #form-container select,\n  #form-container textarea {\n    height: 52px;\n    font-size: 16px;\n  }\n}\n\n/* Toast notification animations */\n@keyframes slide-in {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.animate-slide-in {\n  animation: slide-in 0.3s ease-out;\n}\n\n@keyframes fadeSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
